<template>
  <div class="is-background"></div>

  <header :class="['navbar', { 'scrolled': isScrolled }]">
    <div class="nav-container">
      <div class="logo">Minecraft</div>
      <nav class="nav-links">
        <a href="#">1</a>
        <a href="#">2</a>
        <a href="#">3</a>
        <a href="#">4</a>
      </nav>
    </div>
  </header>

  <main class="main-container">
    <h1>This is my website!</h1>
    <p>There is nothing!</p>
    <h2>By Eddiler</h2>
  </main>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isScrolled = ref(false)

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

const handleScroll = () => {
  isScrolled.value = window.scrollY > 20
}

</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.is-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: url("@/assets/bg.png") no-repeat center/cover;
  z-index: -1;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 80px;
  transition: all 0.3s;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.navbar.scrolled {
  height: 60px;
  background: rgba(255, 255, 255, 0.8);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  font-size: 2rem;
  font-weight: bold;
}

/* 导航栏链接 */
.nav-links {
  display: flex;
  gap: 30px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
}

.main-container {
  padding-top: 100px;
  min-height: 100vh;
  max-width: 1600px;
  margin: 0 auto; /* 水平居中 */

  display: flex;
  flex-direction: column;
  gap: 20px; /* 内容之间垂直间距 */
}
</style>
